import React, { Component } from "react";
// import { FormGroup, Label, Col } from "reactstrap";
// import Select from 'react-select';

import { Row, Col, Select } from 'antd';
import 'antd/dist/antd.css';

const { Option } = Select;

class ReportsDropDown extends Component {

    render() {
        let reportList = [];
        reportList = this.props.reportData;
        reportList.sort(function (a, b) {
            return (a.label.toUpperCase() > b.label.toUpperCase()) ? 1 : -1;
        }); 
        // let drpdwnoptions = this.props.reportData.length > 0 && this.props.reportData.map((item,i)=>{
        let drpdwnoptions = reportList.length > 0 && reportList.map((item,i)=>{
            return(
                <Option key={item.value} value={item.value} >{item.label}</Option>
            );
        }, this);

        console.log('this.props.reportData',this.props.reportData,'this.props.reportVal',this.props.reportVal)
        return (
            
            <Row type="flex" justify="center">
                <Col span={6}>Report Name</Col>
                <Col span={18}>
                    <Select
                        allowClear
                        labelInValue
                        showSearch
                        // value={this.props.reportVal}
                        style={{ width: '100%' }}
                        placeholder="Select a report name"
                        optionFilterProp="children"
                        onChange={(selectedOption) => {
                            console.log('selectedOption',selectedOption)
                            this.props.updateSearchData("Report Name", selectedOption, "mydocs");
                        }}
                        filterOption={(input, option) =>
                            option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                        }
                    >
                        {drpdwnoptions}
                    </Select>
                </Col>
            </Row>
        );
    }    
}

export default ReportsDropDown;